/* EXAMPLE CODE:
*  <div class="dropdown">
        <button class="dropdown-toggle js--dropdown-toggle">Dropdown</button>
               <div class="dropdown-content js--dropdown-content">
                    <a href="#one">One</a>
                    <a href="#two">Two</a>
                    <a href="#three">Three</a>
               </div>
   </div>
* */

document.addEventListener("DOMContentLoaded", () => {
    const button = document.querySelector('.js--dropdown-toggle');

    if (!button) {
        return;
    }

    button.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.currentTarget.classList.toggle('active')
        evt.currentTarget.nextElementSibling.classList.toggle('show')
    }, false);
});
